/*----------------------------------
- MARKET MEGA MENU
----------------------------------*/

import { LANDING_MARKET_MENU_GROUPS } from '@/client/catalogs/landing/marketMenu';
import MegaMenuPanel from './MegaMenuPanel';
import MenuGroupColumns from './MenuGroupColumns';
import type { MenuNavigateHandler } from './navClick';

/*----------------------------------
- TYPES
----------------------------------*/

type MarketMegaMenuProps = {
    id: string;
    isOpen: boolean;
    onNavigate: MenuNavigateHandler;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

/**
 * What the market is doing, in three titled columns with no head (mock parity web-recheck-02): Prices and sales,
 * Endings and dates, Daily editions. Every row of the catalog has a page today; a row without one would render as a
 * disabled row with the Soon tag. No figure and no cadence note: the panel reads nothing from Product (decision 36).
 */
export default function MarketMegaMenu({ id, isOpen, onNavigate }: MarketMegaMenuProps) {
    return (
        <MegaMenuPanel id={id} testId="market-mega-menu" isOpen={isOpen} width="medium">
            <MenuGroupColumns groups={LANDING_MARKET_MENU_GROUPS} density="desktop" onNavigate={onNavigate} testIdPrefix="market-menu-rows" />
        </MegaMenuPanel>
    );
}
